import axiosServices from '@utils/axios';

const backendUrl = import.meta.env.VITE_BACKEND_URL;
const baseUrl = `${backendUrl}/super-admin/impersonation`;

export const getImpersonationStatus = async () => {
  const response = await axiosServices.get(`${baseUrl}/status`);
  return response.data;
};

export const searchImpersonationUsers = async ({ query, limit = 10 }) => {
  const response = await axiosServices.get(`${baseUrl}/users`, {
    params: { query, limit },
  });
  return response.data;
};

export const createImpersonationChallenge = async ({ targetEmail, reason }) => {
  const response = await axiosServices.post(`${baseUrl}/challenge`, {
    target_email: targetEmail,
    reason,
  });
  return response.data;
};

export const startImpersonation = async ({
  challengeId,
  targetEmailConfirmation,
  reason,
  actorPassword,
}) => {
  const response = await axiosServices.post(`${baseUrl}/start`, {
    challenge_id: challengeId,
    target_email_confirmation: targetEmailConfirmation,
    reason,
    actor_password: actorPassword,
  });
  return response.data;
};

export const stopImpersonation = async () => {
  const response = await axiosServices.post(`${baseUrl}/stop`);
  return response.data;
};
